import { render, staticRenderFns } from "./AreaLine.vue?vue&type=template&id=dd453d40&scoped=true&"
import script from "./AreaLine.vue?vue&type=script&lang=js&"
export * from "./AreaLine.vue?vue&type=script&lang=js&"
import style0 from "./AreaLine.vue?vue&type=style&index=0&id=dd453d40&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd453d40",
  null
  
)

export default component.exports